<app-loading-page></app-loading-page>
<app-saving-page></app-saving-page>

<div id="device-list">

  <div id="pagecontent" *ngIf="!isLoadingStaticData && !isSavingData">

    <div class="table-responsive">

      <table mat-table [dataSource]="filteredDevices" [trackBy]="trackById" *ngIf="filteredDevices.length > 0"
             matSort (matSortChange)="onMatSortChange($event)">

        <ng-container matColumnDef="nomeFlotta">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.FleetName' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.nomeFlotta}}
          </td>
        </ng-container>

        <ng-container matColumnDef="nomeMezzo">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.VehicleName' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.nomeMezzo}}
          </td>
        </ng-container>

        <ng-container matColumnDef="targa">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.VehicleLicensePlate' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.targa}}
          </td>
        </ng-container>

        <ng-container matColumnDef="marca">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.VehicleBrand' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.marca}}
          </td>
        </ng-container>

        <ng-container matColumnDef="modello">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.VehicleModel' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.modello}}
          </td>
        </ng-container>

        <ng-container matColumnDef="statoLucchetto">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.LockStatus' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.lockInput?.fieldValue ?? '-'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="statoPorta">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DoorStatus' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.doorInput?.fieldValue ?? '-'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="tipoDispositivo">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DeviceType' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{ row.lockOutput
                ? (row.lockOutput.isManual
                  ? ('Devices.DeviceTypeManual' | translate)
                  : ('Devices.DeviceTypeAutomatic' | translate))
                : '---'
          }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statoDateTime">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DeviceDateTime' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{ row.statoDateTime | date:'dd/MM/yyyy HH:mm:ss' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['nomeFlotta', 'nomeMezzo', 'targa', 'marca', 'modello', 'statoLucchetto', 'statoPorta', 'tipoDispositivo', 'statoDateTime']; sticky: true"></tr>
        <tr mat-row
          *matRowDef="let row; columns: ['nomeFlotta', 'nomeMezzo', 'targa', 'marca', 'modello', 'statoLucchetto', 'statoPorta', 'tipoDispositivo', 'statoDateTime'];"
          (mouseup)="onRowMouseUp($event, row)"></tr>

      </table>

    </div>
  </div>
</div>